import React, { useEffect, useState } from 'react'
import { Get_Custom_Designs, custom_jewellery } from '../../../../api/global/Global'
import { IMG_BASE_URL } from '../../../../config/Config'
import { isValidEmail } from '../../../validation/Validation';
import { toast } from 'react-toastify';

const Home_Exclusive_Design = () => {
    const [isOpen_Custom_video, set_Is_Open_Custom_Video] = useState(false);
    const [customDesigns, setCustomdesigns] = useState(null)
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedDesignId, setSelectedDesignId] = useState(null);
    const [modalForm, setModalForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        country_code: '+91' // Default country code
    });
    const Handle_Is_Open_Custom_video = (videoUrl) => {
        set_Is_Open_Custom_Video(!isOpen_Custom_video);
        setSelectedVideo(videoUrl)
    };

    // Handle modal form input changes
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone" && value.length > 10) {
            return
        }

        if (name === "email") {
            if (!isValidEmail(value)) {
                setErrorMessage("Please enter a valid email address");
            } else {
                setErrorMessage("");
            }
        }
        setModalForm(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const resetMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
    };

    const handleWriteToUs = (designId) => {
        setSelectedDesignId(designId);
        setShowModal(true);
        resetMessages();
    };

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        resetMessages();

        if (!modalForm.email || !isValidEmail(modalForm.email)) {
            toast("Please enter a valid email address.");
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', modalForm.name);
            formData.append('email', modalForm.email);
            formData.append('country_code', modalForm.country_code);
            formData.append('mobile', modalForm.phone);
            formData.append('message', modalForm.message);

            if (selectedDesignId) {
                formData.append('custom_design_id', selectedDesignId?.id);
            }

            const response = await custom_jewellery({
                method: 'POST',
                body: formData,
            })

            // Adjust based on your API response structure
            const result = response.data;

            if (result?.status == 200) {
                setSuccessMessage(result?.message || 'Your request has been submitted successfully!');
                setModalForm({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    country_code: '+91'
                });

                setTimeout(() => {
                    setShowModal(false);
                    setSuccessMessage('');
                }, 2000);
            }
            if (response?.response?.data?.status == 500) {
                setErrorMessage(response?.response?.data?.message || 'Failed to submit your request.');
            }
        } catch (error) {
            console.error('Error submitting modal form:', error);
            setErrorMessage('Failed to submit your request. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const closePopUp = () => {
        setShowModal(false)
        setModalForm({
            name: '',
            email: '',
            phone: '',
            message: '',
            country_code: '+91'
        });

    }

    useEffect(() => {
        const getcustom_designs = async () => {
            try {
                const response = await Get_Custom_Designs()
                if (response?.data?.status == 200) {
                    setCustomdesigns(response?.data?.data?.custom_design)
                }

            } catch (error) {
                console.error(error.message);

            }
        }
        getcustom_designs()
    }, [])

    const customDesignFix = customDesigns?.slice(0, 8)

    return (
        <div>
            <section className="gi-deal-section bg-[#f1f1f1] px-5 py-[40px] max-[767px]:py-[30px] wow fadeInUp" data-wow-duration="2s">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="w-full flex flex-wrap px-[12px] overflow-hidden">
                        <div className="gi-deal-section w-full">
                            <div className="gi-products">
                                <div className="section-title mb-[20px] relative text-center pb-[20px] z-[5]" data-aos="fade-up"
                                    data-aos-duration="2000" data-aos-delay="200">
                                    <div className="section-detail">
                                        <h2
                                            className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                                            Exclusive Custom Designs</h2>
                                        <p className="mt-[5px] text-[14px] font-semibold text-gray-700 capitalize">Artistic Expression in Terms
                                            of Jewellery</p>
                                    </div>

                                </div>
                                <div className="gi-deal-block" data-aos="fade-up" data-aos-duration="2000"
                                    data-aos-delay="300">
                                    <div
                                        className="custome_jewellery grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1">
                                        {
                                            customDesignFix?.map((designs) => (

                                                <div className="gi-products bg-no-repeat text-center bg-cover h-[300px] overflow-hidden"
                                                    style={{
                                                        backgroundImage: `url(${IMG_BASE_URL}/${designs?.thumbnail_img})`, // Add your image URL here
                                                    }}
                                                >
                                                    <div
                                                        className="bg-gradient-to-t relative from-[#000] opacity-0 hover:opacity-100 p-5 flags h-full">

                                                        {designs?.video && (
                                                            <button onClick={() => { Handle_Is_Open_Custom_video(`${IMG_BASE_URL}${designs?.video}`) }}>
                                                                <div
                                                                    className="absolute w-12 rounded-full leading-[52px] h-12 bg-white m-auto left-0 right-0 top-0 bottom-0">
                                                                    <i className="fi-rr-play" ></i>
                                                                </div>
                                                            </button>
                                                        )}

                                                        <button className="absolute bottom-0 left-0 w-full" >
                                                            <div
                                                                className=" inset-center text-white mx-4 mb-4 border px-3 text-sm rounded-full py-2 hover:bg-[#9F2225] hover:border-gray-900" onClick={() => handleWriteToUs(designs)}>
                                                                Write to us</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <-------- Modal section's Custome Video ----------> */}
            {
                isOpen_Custom_video && selectedVideo && (
                    <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50">
                        {/* <!-- Modal Content --> */}
                        <div className="bg-white max-w-md">
                            {/* <!-- Modal Header --> */}
                            <div className="flex justify-between items-center px-3">
                                <h2 className="text-[13px] m-0 font-semibold text-gray-900 uppercase">Custome Video</h2>
                                <button className="text-[#9F2225] hover:text-gray-800 text-[25px]" onClick={Handle_Is_Open_Custom_video}>
                                    &times;</button>
                            </div>

                            {/* <!-- Modal Body --> */}
                            <div className="text-gray-700">
                                <video controls>
                                    <source src={selectedVideo} type="video/mp4" />
                                </video>
                            </div>


                        </div>
                    </div>
                )
            }

            {/* popup */}
            <div className={`p-10 ${!showModal ? 'hidden' : 'block'} fixed inset-0 z-30 bg-gray-950/90 h-full overflow-hidden`}>
                {/* <button
                                onClick={() => setShowModal(true)}
                                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            >
                                Open Modal
                            </button> */}
                <div className="flex h-full justify-center items-center">
                    <div className="mx-auto bg-white p-5 w-[500px] rounded relative">
                        <div isOpen={showModal} onClose={() => setShowModal(false)}>
                            <button
                                onClick={closePopUp}
                                className="absolute -top-4 -right-4 font-bold text-xl bg-red-700 text-white w-8 h-8 text-center inline-block rounded-full pb-1 border border-white">x</button>
                            <div>
                                <div className="text font-semibold text-lg">Submit Your Request</div>
                                <div className="text-gray-700 text-[13px] font-medium mb-4">18K Yellow Gold Blue Sapphire With Diamond Ring</div>
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <img className="w-full" src={`${IMG_BASE_URL}${selectedDesignId?.thumbnail_img}`} alt="jewellery" />
                                </div>
                                <div>
                                    <form onSubmit={handleModalSubmit} className="flex flex-row flex-wrap">
                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Name</label>
                                            <input type="text"
                                                placeholder="Enter your name"
                                                name="name"
                                                value={modalForm.name}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>

                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Email ID </label>
                                            <input type="email"
                                                name="email"
                                                placeholder="Enter your e-mail here"
                                                value={modalForm.email}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>
                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Phone Number </label>
                                            <input type="phone"
                                                name="number"
                                                placeholder="Enter Your Phone Number Here"
                                                value={modalForm.phone}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>

                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Message </label>
                                            <textarea
                                                placeholder="Enter Your Message Here"
                                                name='message'
                                                value={modalForm.message}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 p-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none"
                                                required />
                                        </div>

                                        {successMessage && (
                                            <div className="bg-green-100 border border-green-400 text-green-700 px-3 py-2 rounded text-xs">
                                                {successMessage}
                                            </div>
                                        )}

                                        {errorMessage && (
                                            <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded text-xs">
                                                {errorMessage}
                                            </div>
                                        )}

                                        <div className="w-full px-[6px]">
                                            <button type="submit"
                                                disabled={loading}
                                                className="text-[12px] mx-auto w-full uppercase inline-block border border-red-700 bg-red-700 text-white font-semibold px-6 py-2 hover:bg-red-700 hover:text-white">
                                                {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                            </button>
                                        </div>


                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* popup end */}

        </div>
    )
}

export default Home_Exclusive_Design